import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";


const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
  }
`;


const Nav = styled.div`
  background: rgba(0, 0, 0, 1);
  padding: 12px 75px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-family: JetBrains Mono;
`;


const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export default function Navbar(props) {

  return (
    <>      
      <Mobile style={{padding: 8}}>
        
      </Mobile>
      <Desktop>
      <Nav>
        <HorizontalWrapper>
            <label style={{ marginLeft: 0, fontFamily: "JetBrains Mono", fontSize: 20 }}>
                GAMES.GG
            </label>
         </HorizontalWrapper>
       
        </Nav>
      </Desktop>
    </>
  );
}

